<template>
  <div id="full-input-size">
    <NxInput
      name="observacao"
      type="textarea"
      label="Observações:"
      :placeholder="placeholder"
      @update:value="handleValueUpdate"
    ></NxInput>
    <small
      class="small-help"
      style="border-radius: 0px 0px 0.3rem 0.3rem"
    >
      <i class="fas fa-microphone"></i> utilize o microfone no teclado do
      celular para registrar o comentário (voz para texto).
    </small>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputObservacao',
  mixins: [useReactiveModelMixin('value')],
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>

<style lang="scss">
#full-input-size {
  .formulate-input {
    margin-bottom: 0px;

    .formulate-input-element {
      max-width: none;

      textarea {
        height: 7rem;
        border-radius: 0.3rem 0.3rem 0px 0px;
        resize: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputObservacao.vue